import {TypeName, Traceable} from "./interfaces";

/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export interface IGenericBaseEntity {
  updateFromQuery(_instance: unknown): void
}

/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export abstract class AbstractBaseEntity implements Traceable, TypeName, IGenericBaseEntity {
  id?: any;
  creationTime: string;
  updatedTime: string;
  __typename: string;

  public abstract updateFromQuery(_instance: unknown): void
}
